export default __webpack_public_path__ + "static/local_love_heading_bg_img-a6a07cfd2df0916436a4541cc6a89f58.png";